import mime from "mime-types";

// const checkMediaType = (ext) => {

// }

const typeFromMime = (ext) => {
  const [type] = mime.lookup(ext).split("/");
  return type;
};

export const filetypeByUrl = async (url, forceType) => {
  if (forceType) return forceType;

  const res = await fetch(url);
  const fetchedType = res.headers.get("Content-Type");
  const ext = mime.extension(fetchedType);
  return typeFromMime(ext);
};
